import { MODEL_CHANGE, MODEL_STATE_UPDATE, MODEL_UPDATED } from './../actions/modelDetails';

const modelChangeReducer = (state = {}, { type, modelPayload }) => {
    switch (type) {
        case MODEL_CHANGE:
            return { ...state, modelPayload }
        default:
            return state
    }
};

const modelUpdateReducer = (state = {}, { type, status }) => {
    switch (type) {
        case MODEL_STATE_UPDATE:
            return { ...state, status }
        default:
            return state
    }
};

const setModifiedDateReducer = (state = {}, { type, datePayload }) => {
    switch (type) {
        case MODEL_UPDATED:
            return { ...state, datePayload }
        default:
            return state
    }
};

export { modelChangeReducer, modelUpdateReducer, setModifiedDateReducer };